
import { mapState, mapMutations, mapActions } from 'vuex'
import Radar from '~/node_modules/radar-sdk-js'
import Icon from '../Icon'

export default {
  name: 'LocationSearch',
  components: {
    Icon,
  },
  computed: {
    ...mapState([ 'loading', 'appInfo' ]),
    appRadar() {
      return this.appInfo['radar_map']
    },
    isMobile() {
      return this.$mq == 'sm' || this.$mq == 'md' ? true : false
    },
    seachFieldPlaceholder() {
      if (this.appRadar['location_search_field_placeholder']) {
        return this.appRadar['location_search_field_placeholder']
      }

      return this.isMobile ? 'Search' : 'Search for a restaurant'
    },
  },
  props: {
    findMe: {
      type: Object,
      default: () => {},
    },
    filterBy: {
      type: Object,
      default: () => {},
    },
    allLocations: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      query: '',
      firstResult: null,
    }
  },
  mounted() {
    const radarKey = process.env.RADAR_KEY
    if (!radarKey) {
      this.$utils.log('LocationSearch - RADAR_KEY is missing')
      return
    }

    setTimeout(() => {
      // Initialize Radar SDK
      Radar.initialize(radarKey)

      // Create autocomplete widgets
      Radar.ui.autocomplete({
        container: 'autocomplete',
        responsive: true,
        countryCode: this.appRadar['country'] || '',
        layers: this.appRadar['layers'] || '',
        placeholder: this.seachFieldPlaceholder,
        onSelection: (result) => {
          if (this.appRadar['location_coord_search']) {
            this.coordSearch(result)
          } else {
            this.query = result[this.appRadar['location_search_field']]
            this.addressSearch(this.query)
          }
        },
        onResults: (results) => {
          if (results && results.length > 0) {
            this.firstResult = results[0]
          }
        }
      })

      // Add autofill functionality
      this.$nextTick(() => {
        document.addEventListener('keyup', (e) => {
          if (e?.target?.parentElement?.parentElement?.id === 'autocomplete') {
            this.query = e.target.value
          }

          if (e.key === 'Enter' || e.keyCode === 13) {
            if (this.firstResult) {
              if (this.appRadar['location_coord_search']) {
                this.coordSearch(this.firstResult)
              } else {
                this.query = this.firstResult[this.appRadar['location_search_field']]
                this.addressSearch(this.query)
              }
            } else {
              setTimeout(() => { // wait for radar result
                if (this.firstResult) {
                  if (this.appRadar['location_coord_search']) {
                    this.coordSearch(this.firstResult)
                  } else {
                    this.query = this.firstResult[this.appRadar['location_search_field']]
                    this.addressSearch(this.query)
                  }
                }
              }, 1000)
            }
          }
        })

        // Optional search locations on pageload
        if (this.appRadar['search_on_load']) {
          this.addressSearch(this.query)
        }
      })
    }, 200)
  },
  methods: {
    ...mapMutations({
      setAddress: 'locations/setAddress'
    }),
    ...mapActions({
      addressSearch: 'locations/addressSearch',
      coordSearch: 'locations/coordSearch',
    }),
  },
}
